<template>
  <a-table
      :columns="columns"
      :data-source="data"
      :pagination="{ hideOnSinglePage: true, defaultPageSize: 5 }"
      rowKey="id"
      :locale="{ emptyText: 'No Freightmate' }"
      :loading="loading"
      :scroll="{ x: true }"
  >
    <template slot="id" slot-scope="id, record, index">
      <a-popover placement="bottom">
        <template slot="content">
          <span>Battery: {{ record.battery }}</span>
        </template>
        <span>{{ id.toString().substring(4) }}</span>
      </a-popover>
    </template>

    <template slot="bookingId" slot-scope="bookingId">
      <span v-if="bookingId === 'N/A'">N/A</span>
      <a v-else :href="'/send-freight/bookings/' + bookingId" target="_blank">{{ bookingId }}</a>
    </template>

    <template slot="updatedAt" slot-scope="moment">
      <span v-if=" moment === '' ">N/A</span>
      <a-popover v-else placement="bottom">
        <template slot="content">
          <span>{{ moment.format('h:mm a, Do MMMM YYYY') }}</span><br>
        </template>
        <span>{{ moment.fromNow() }}</span>
      </a-popover>
    </template>

    <template slot="currentLocation" slot-scope="currentLocation">
      <span>{{ currentLocation }}</span>
    </template>

    <template slot="previousLocation" slot-scope="previousLocation">
      <span>{{ previousLocation }}</span>
    </template>

    <template slot="unlinkedAt" slot-scope="moment">
      <span v-if=" moment === '' ">N/A</span>
      <a-popover v-else placement="bottom">
        <template slot="content">
          <span>{{ moment.format('h:mm a, Do MMMM YYYY') }}</span><br>
        </template>
        <span>{{ moment.fromNow(true) }}</span>
      </a-popover>
    </template>

    <template slot="history" slot-scope="text, record, index">
      <div>
        <freight-mate-movements-map :tracker-id="parseInt(record.id)" :type="type" :asset-name="record.assetName"></freight-mate-movements-map>
      </div>
    </template>

    <template slot="options" slot-scope="text, record, index">
      <div>
        <!-- On-site Options -->
        <span v-if="type === 'on-site'">
          <information-modal title="How to reuse?">
            <template v-slot:button>
              <a href="#" @click.prevent="">Reuse</a>
            </template>
            <p>If you send freight, reuse this tracker by placing a freight booking. Real-time tracking is free if your freight is sent with Freighthub, or $5 (+GST) for freight sent with other carriers.</p>
          </information-modal>
          <information-modal title="How to recycle?">
            <template v-slot:button>
              <a href="#" @click.prevent="">Recycle</a>
            </template>
            <p>This tracking device can be gifted to any business that sends B2B freight. Let them experience the convenience of knowing where their freight is at all times.</p>
          </information-modal>
          <information-modal title="How to return?">
            <template v-slot:button>
              <a href="#" @click.prevent="">Return</a>
            </template>
            <p>If you can't reuse or recycle this tracker, please return it to Freighthub by dropping it into any NZ Post mailbox free of charge. Thanks!</p>
          </information-modal>
        </span>

        <!-- Off-site Options -->
        <span v-if="type === 'off-site'">
          <information-modal title="Contact">
            <template v-slot:button>
              <a href="#" @click.prevent="">Contact</a>
            </template>
            <p>How to contact?</p>
          </information-modal>
        </span>

        <!-- Assets Options -->
        <span v-if="type === 'assets'">
          <a-button
            @click="trackerToDelete = record.id"
            type="button"
            class="btn-outline-primary"
          >
            Delete
          </a-button>
          <a-modal
            v-model="showDeleteTrackerModal"
            :title="'Confirming asset deletion'"
            :confirm-loading="deletingTracker"
            @ok="deleteAssetTracker"
            @cancel="trackerToDelete = null"
          >
            <p>Please confirm you wish to delete further tracking of this asset?</p>
          </a-modal>
        </span>
      </div>
    </template>
  </a-table>
</template>

<script>
import InformationModal from "../modals/Information";
import FreightMateMovementsMap from "../modals/FreightMateMovementsMap";

export default {
  name: "FreightMates",
  components: {
    FreightMateMovementsMap,
    InformationModal,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      deletingTracker: false,
      trackerToDelete: null
    }
  },
  computed: {
    showDeleteTrackerModal() {
      return !!this.trackerToDelete;
    },
  },
  methods: {
    deleteAssetTracker() {
      console.log(this.trackerToDelete);
      this.deletingTracker = true;
      axios
        .delete("/send-freight/tracker/business/" + this.trackerToDelete)
        .then((res) => {
          this.trackerToDelete = null;
          this.trackerNumber = null;
          this.$swal({
            title: "Asset tracker deleted!",
            type: "success",
          });
          this.deletingTracker = false;
          this.$emit('trackerDeleted');
        })
        .catch((err) => {
          this.$swal({
            title: "Please try again or contact us",
            type: "error",
          });
          this.deletingTracker = false;
        });
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 768px) {
  >>> .ant-table-body {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
  }
  >>> .ant-table-body::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
  }
}

</style>
